import EmptyState from "../UI/EmptyState";
import TalentoRow from "./TalentoRow";

const TalentosTable = ({ talentos, search }) => {
  if (!talentos || talentos.length === 0) {
    return (
      <EmptyState
        icon={search ? "mdi:magnify-remove-outline" : "mdi:star-outline"}
        title={
          search ? "No se encontraron talentos" : "No hay talentos para mostrar"
        }
        description={search ? "Intenta con otra búsqueda" : null}
      />
    );
  }

  return (
    <div className="table-responsive scroll-sm">
      <table
        className="table bordered-table mb-0"
        style={{ minWidth: "900px" }}
      >
        <thead>
          <tr>
            <th scope="col" style={{ minWidth: "200px" }}>
              Nombre
            </th>
            <th scope="col" style={{ minWidth: "100px" }}>
              Estatus
            </th>
            <th scope="col" style={{ minWidth: "80px" }}>
              Acciones
            </th>
          </tr>
        </thead>
        <tbody>
          {talentos.map((talento) => (
            <TalentoRow key={talento.id} talento={talento} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TalentosTable;
